import {
  UPDATE_LOADING_STATUS,
  FETCH_APPMANGE_DATA_LIST,
  GET_BLACKLISTNULL_LIST
} from "../actions/standardPanel";

const defVal = {
  dataListLoading: false,
  dataList: [],
  dataListTotal: 0,
  isDataList: true
};

export default (state = defVal, action) => {
  switch (action.type) {
    case UPDATE_LOADING_STATUS:
      return Object.assign({}, state, {
        dataListLoading: action.loading
      });

    case FETCH_APPMANGE_DATA_LIST:
      return Object.assign({}, state, {
        dataList: action.dataList,
        dataListTotal: action.dataListTotal,
      });
    case GET_BLACKLISTNULL_LIST:
      return Object.assign({}, state, {
        isDataList: action.isDataList || false,
      });
    default:
      return state;
  }
};
